import React, { useState, Fragment, useEffect } from 'react';
import { Hero, Middle, Intro, Background, Bottom, Reviews } from '.';
import { Apps, Outro } from '../common';
import { Document, Image, Sections } from 'components';
import { useToggle } from 'helpers';
import images from 'brand/home/hero';

export function Home(props) {
  const [ current, setCurrent ] = useState(0);
  const [ ready, setReady ] = useToggle();
  const [ running, setRunning ] = useToggle();

  useEffect(() => {
    if (running) {
      const interval = setInterval(() => setCurrent(val => (val + 1) % images.length), 5000);
      return () => clearInterval(interval);
    }
  }, [ running ]);

  return (
    <Fragment>
      <Document.Title />
      <Image.Loader src={images[0]} onLoad={setReady} />
      <Image.Loader src={images[0]} onLoad={props.setReady} />
      { ready && <Image.Loader src={images[1]} onLoad={setRunning} /> }
      <Sections {...props} images={images} current={current} Background={Background}>
        {{ Hero, Intro, Middle, Apps, Reviews, Bottom }}
      </Sections>
      <Outro />
    </Fragment>
  );
}
